import React from "react";
import { Box, Paper, Stack, Typography, Avatar, alpha } from "@mui/material";
import { useTheme } from "@mui/material/styles";

/**
 * Butun yonetici sayfalarinin ortak kabugu.
 *
 * Daha once her sayfa kendi arka planini, dolgusunu, kose yariçapini ve baslik
 * duzenini ayri ayri yaziyordu (kimi p:1, kimi p:3, kimi p:{xs:2,md:4}; arka
 * plan kimi yerde #f4f6f8, kimi yerde #f8f9fa, kimi yerde yok). Bu yuzden
 * sayfalar farkli temalardan alinmis gibi duruyordu. Artik hepsi buradan
 * besleniyor; sayfanin kendi icerigi degismiyor.
 */

export const SAYFA_ARKAPLAN = "#F4F6F8";
export const PANEL_KENARLIK = "1px solid #eaecf0";
export const PANEL_YARICAP = 3;

export default function PageShell({
  title,
  subtitle,
  icon,
  chip,
  actions,
  children,
}) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        p: { xs: 2, md: 3 },
        bgcolor: SAYFA_ARKAPLAN,
        minHeight: "100vh",
      }}
    >
      {(title || actions) && (
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          spacing={2}
          sx={{ mb: 3 }}
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            {icon && (
              <Avatar
                variant="rounded"
                sx={{
                  bgcolor: alpha(theme.palette.primary.main, 0.1),
                  color: "primary.main",
                  width: 44,
                  height: 44,
                }}
              >
                {icon}
              </Avatar>
            )}
            <Box>
              <Stack direction="row" alignItems="center" spacing={1.5}>
                <Typography
                  variant="h5"
                  sx={{
                    fontFamily: "'Montserrat', sans-serif",
                    fontWeight: 700,
                    color: "text.primary",
                  }}
                >
                  {title}
                </Typography>
                {chip}
              </Stack>
              {subtitle && (
                <Typography variant="body2" color="text.secondary">
                  {subtitle}
                </Typography>
              )}
            </Box>
          </Stack>

          {actions && (
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              flexWrap="wrap"
              useFlexGap
            >
              {actions}
            </Stack>
          )}
        </Stack>
      )}

      {children}
    </Box>
  );
}

/**
 * Sayfa icindeki standart panel/kart. Filtre cubugu, form kutusu vb. icin.
 * accent verilirse (ornegin duzenleme modunda) kenarlik o renge doner.
 */
export function PanelCard({ children, accent, sx = {}, ...rest }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, md: 2.5 },
        mb: 3,
        borderRadius: PANEL_YARICAP,
        border: accent ? `2px solid ${accent}` : PANEL_KENARLIK,
        bgcolor: "#fff",
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Paper>
  );
}
